export default "__VITE_ASSET__D54$zct2__"